<template>
  <div>
    <v-row v-for="(be, i) in emails" 
    :key="i"  
    dense 
    no-gutters 
    class="mt-2">
      <v-col>
        <text-field-email
        :label="$t('textFields.email')"
        v-model="be.value"
        required
        @click:append="$emit('remove', be)"
        append-icon="mdi-minus"/>
      </v-col>
    </v-row>
    <v-row class="mt-2">
      <v-col class="d-flex justify-center align-center">
        <icon-button
        @click="$emit('add')"
        src="plus"
        color="blue"/>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import TextFieldEmail from '@/components/text-fields/TextFieldEmail'
import IconButton from '@/components/btns/IconButton'
export default {
  components: {
    TextFieldEmail,
    IconButton
  },
  props: {
    emails: {
      type: Array,
      required: true
    }
  }
}
</script>
<style>

</style>